import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';


const DeleteItemCheck = ({ id, onConfirm, alertMessage }) => {
    const dispatch = useDispatch();
    const [alert, setAlert] = useState(false);

    const toggle = () => {
        setAlert(!alert);
    };

    return (
        <Fragment>
            <Button size="sm" color="primary" onClick={() => toggle()}>
                <i className="zmdi zmdi-edit zmdi-hc-fw" />
                <span>{<IntlMessages id="label.delete" />}</span>
            </Button>
            <SweetAlert show={alert}
                warning
                showCancel
                confirmBtnText={<IntlMessages id="button.yesDeleteIt" />}
                cancelBtnText={<IntlMessages id="button.cancel" />}
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title={<span style={{ fontWeight: 'bold', color: 'grey', fontSize: '200%' }}><IntlMessages id="general.areYouSure" /></span>}
                onConfirm={() => {
                    dispatch(onConfirm(id));
                    toggle();
                }}
                onCancel={() => toggle()}
            >
                {alertMessage}
            </SweetAlert>
        </Fragment>
    );
};

export default DeleteItemCheck;


// WEBPACK FOOTER //
// ./components/deleteItemCheck/index.js